import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as verifyEmailReducer from '../reducers/verify-email.reducer';
import * as fromAuthReducer from '../auth.reducer';

//#region AUTH ROOT STATE
export const getAuthState = createFeatureSelector<fromAuthReducer.State, fromAuthReducer.AuthState>(fromAuthReducer.authFeatureKey);
//#endregion

//#region VALIDATE GOV ID AND PASSPORT NUMBER SUB STATE
export const getVerifyEmailState = createSelector(getAuthState, state => state[verifyEmailReducer.verifyEmailFeatureKey]);

export const getVerifyEmailIsLoading = createSelector(
  getVerifyEmailState,
  verifyEmailReducer.getVerifyEmailIsLoading
);

export const getVerifyEmailRequest = createSelector(
  getVerifyEmailState,
  verifyEmailReducer.getVerifyEmailRequest
);

export const getVerifyEmailResponse = createSelector(
  getVerifyEmailState,
  verifyEmailReducer.getVerifyEmailResponse
);

export const getVerifyEmailFailure = createSelector(
  getVerifyEmailState,
  verifyEmailReducer.getVerifyEmailFailure
);
